import { initializeFaro, TransportItemType } from '@grafana/faro-web-sdk';
import { combineConfigRefs, configFromEnv } from '@utils/config';
import { makeEventTrackingProvider } from './_provider.js';

let faro = void 0;
const configRef = combineConfigRefs({
  endpoint: configFromEnv.asString("GRAFANA_FARO__ENDPOINT"),
  apiKey: configFromEnv.asString("GRAFANA_FARO__API_KEY")
});
function getFaroInstance(context) {
  if (faro || faro === null) {
    return faro;
  }
  const config = configRef.dangerouslyAssertSyncValue();
  if (!config.endpoint || !config.apiKey) {
    console.warn(
      "getFaroInstance(): Grafana faro is not available due to missing configuration variables."
    );
    faro = null;
    return faro;
  }
  const instance = initializeFaro({
    url: config.endpoint,
    apiKey: config.apiKey,
    app: {
      name: context.app.name,
      environment: process.env["APP_ENV"]
    },
    batching: {
      enabled: true
    },
    sessionTracking: {
      enabled: false
    },
    dedupe: false,
    trackWebVitalsAttribution: false,
    /**
     * We only use Grafana Faro to track our own custom events
     */
    beforeSend: (item) => {
      if (item.type !== TransportItemType.EVENT) {
        return null;
      }
      if ("name" in item.payload && item.payload.name.startsWith("faro.")) {
        return null;
      }
      return item;
    }
  });
  faro = instance;
  return faro;
}
const GrafanaFaroEventTrackingProvider = makeEventTrackingProvider({
  handleEvent: (name, args, context) => {
    const faro2 = getFaroInstance(context);
    if (!faro2) {
      return;
    }
    const eventAttributes = {
      productId: context.product.id,
      productTitle: context.product.title,
      productAudience: context.product.audience,
      userRole: context.user.role,
      ...args === true ? {} : args
    };
    faro2.api.pushEvent(name, eventAttributes);
  }
});

export { GrafanaFaroEventTrackingProvider };
//# sourceMappingURL=integration.grafana-faro.js.map
